import React, { useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import MenuBanner from "./MenuBanner";
import NavigationDrawer from "manager-panel/NavigationDrawer";
import AudioViewerDialog from "media-viewer/AudioViewerDialog";
import EpubViewerDialog from "media-viewer/EpubViewerDialog";
import ImageViewerDialog from "media-viewer/ImageViewerDialog";
import ImageBookViewerDialog from "media-viewer/ImageBookViewerDialog";
import PdfViewerDialog from "media-viewer/PdfViewerDialog";
import VideoViewerDialog from "media-viewer/VideoViewerDialog";
import {
  VIEWER_AUDIO,
  VIEWER_EPUB,
  VIEWER_IMAGE,
  VIEWER_PDF,
  VIEWER_VIDEO,
  VIEWER_IMAGE_BOOK,
} from "media-viewer/mediaViewerRedux";
import { Box } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },

  content: {
    padding: theme.spacing(6),
    height: "100%",
  },
}));

const ManagerPanel = ({ children }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { openViewer } = useSelector(state => state.mediaViewer);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box id="manager-panel" className={classes.root}>
      <MenuBanner open={!open} onClick={handleDrawerOpen} />
      <NavigationDrawer open={open} onClose={handleDrawerClose} />
      <Box id="manager-panel-content" className={classes.content}>
        {children}
      </Box>
      {VIEWER_AUDIO === openViewer && <AudioViewerDialog />}
      {VIEWER_EPUB === openViewer && <EpubViewerDialog />}
      {VIEWER_IMAGE === openViewer && <ImageViewerDialog />}
      {VIEWER_IMAGE_BOOK === openViewer && <ImageBookViewerDialog />}
      {VIEWER_PDF === openViewer && <PdfViewerDialog />}
      {VIEWER_VIDEO === openViewer && <VideoViewerDialog />}
    </Box>
  );
};

export default ManagerPanel;
